import { ADMIN_JUNCTURE_LIST } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADMIN_JUNCTURE_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_JUNCTURE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADMIN_JUNCTURE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
